<div>
    <canvas baseChart width="600" height="200"
        chartType="doughnut"
        [data]="chartData"
        [labels]="chartLabels"
        [plugins]="chartPlugins">
    </canvas>

    <button mat-button
        mat-raised-button
        disabled
        color="primary"
        (click)="randomizer()">
        Randomize (WIP)
    </button>
</div>
